<template>
  <ui-menu-item
    :tooltip-content="tooltipContent"
    :data-testid="`dropdown-item-${props.option[props.propToCheck]}`"
    :data-index="props.option[props.propToCheck]"
    :auto-height="separator"
    :disabled="isDisabledOption"
    :selectable="!disabled"
    :checkbox="Modes.Multiple === mode && !separator"
    :selected="selected"
    :indeterminate="indeterminate"
    @check="handleCheck"
    @select="handleSelect"
  >
    <template v-if="$slots['option-icon']" #icon>
      <slot name="option-icon" :option="props.option" />
    </template>
    <slot name="option" :option="props.option">{{ props.option[props.label] }}</slot>
  </ui-menu-item>
</template>

<script lang="ts" setup generic="T extends object, K extends keyof T, L extends keyof T, M extends Modes">
import { computed } from 'vue'

import UiMenuItem from '../UiMenu/UiMenuItem.vue'

import { Modes } from './types'

const props = defineProps<{
  selected: boolean
  indeterminate: boolean
  mode: M
  option: T
  label: L
  disabled: boolean
  separator: boolean
  propToCheck: K
}>()

const emit = defineEmits<{
  toggle: [value: any]
}>()

const handleCheck = () => handleClick()

const handleSelect = (e?: MouseEvent | KeyboardEvent) => {
  e?.preventDefault()
  handleClick()
}

const isDisabledOption = computed(() => !!('disabled' in props.option && !!props.option.disabled))

const getTooltipContent = (option: T) => ('tooltip' in option ? (option.tooltip as string) : undefined)

const tooltipContent = computed(() => (isDisabledOption.value ? getTooltipContent(props.option) : undefined))

const handleClick = () => {
  if (isDisabledOption.value) return

  emit('toggle', props.option)
}
</script>
